import { Grid } from "@material-ui/core";
import { useFormik } from "formik";
import { LicenceInfoObject } from "../../pages/sale/SalePage";
import { isNullOrUndefined } from "../../utils/CommonFunctions";
import RxButton from "../RxButton";
import RxMaskedTextField from "../RxMaskedTextField";
import RxSelectBox from "../RxSelectBox";
import styles from "./RxProductActionContent.module.css";
import RxProductActionContentValidation from "./RxProductActionContentValidation";

export interface AddCartClickProps {
	licence: string;
	quantity: number;
	productId: number;
	licenceEys: string;
	licenceShouldSendNull: boolean;
	couponId: number;
}

interface RxProductActionContentProps {
	licences?: LicenceInfoObject[];
	productId: number;
	categoryType: string;
	parentProductSelectable: boolean;
	maxNumberOfProduct: number;
	minNumberOfProduct: number;
	couponId?: number;
	onAddCartClick: (properties: AddCartClickProps) => void;
}

const RxProductActionContent = (props: RxProductActionContentProps) => {
	const formik = useFormik({
		initialValues: {
			licence: props.parentProductSelectable ? "" : "Yeni Lisans",
			quantity: props.minNumberOfProduct,
			productId: props.productId,
			licenceEys:
				props.categoryType === "EYS" &&
				props.licences &&
				props.licences.length > 0
					? props.licences[0].serialNumber
					: null,
			licenceShouldSendNull:
				props.categoryType === "EYS" && !props.parentProductSelectable,
			couponId: props.couponId,
		} as AddCartClickProps,
		validationSchema: RxProductActionContentValidation,
		validateOnBlur: true,
		validateOnChange: true,
		onSubmit: () => {
			props.onAddCartClick(formik.values);
		},
	});

	const getFormikQuantity = () => {
		return isNullOrUndefined(formik.values.quantity) ||
			formik.values.quantity.toString() === "_"
			? 0
			: formik.values.quantity;
	};

	return (
		<form
			onBlur={formik.handleBlur}
			onSubmit={formik.handleSubmit}
			className={styles.mainForm}
		>
			<Grid
				container
				spacing={1}
				direction="row"
				justifyContent="center"
				alignItems="center"
				alignContent="center"
			>
				<Grid item xs={12} sm={12}>
					{props.categoryType !== "EYS" && (
						<RxSelectBox
							fullwidth
							required
							id="licence"
							name="licence"
							label="Lisans Seçimi"
							placeholder="Lisans Seçiniz"
							variant="outlined"
							size="small"
							value={formik.values.licence}
							onChange={formik.handleChange}
							onBlur={formik.handleBlur}
							items={
								props.parentProductSelectable
									? props.licences?.map((licence) => ({
											label: licence.serialNumber,
											value: licence.serialNumber,
									  }))
									: [
											{
												label: "Yeni Lisans",
												value: "Yeni Lisans",
											},
									  ]
							}
							error={Boolean(formik.errors.licence)}
						/>
					)}
				</Grid>
				<Grid item xs={1} sm={1}></Grid>
				<Grid item xs={4} sm={4}>
					<RxButton
						color="inherit"
						variant="contained"
						label="-"
						id="minus_button"
						size="small"
						onClick={() => {
							const quantityControl = getFormikQuantity();
							if (quantityControl > props.minNumberOfProduct) {
								formik.setFieldValue("quantity", quantityControl - 1);
							}
						}}
					/>
				</Grid>
				<Grid item xs={2} sm={2}>
					<RxMaskedTextField
						fullwidth
						required
						alwaysShowMask
						size="small"
						variant="filled"
						id="quantity"
						name="quantity"
						mask="99"
						value={
							formik.values.quantity < 10
								? "0" + formik.values.quantity.toString()
								: formik.values.quantity.toString()
						}
						onChange={formik.handleChange}
						onBlur={formik.handleBlur}
						inputClassName={styles.maskedInput}
					/>
				</Grid>
				<Grid item xs={4} sm={4}>
					<RxButton
						color="inherit"
						variant="contained"
						label="+"
						id="plus_button"
						size="small"
						onClick={() => {
							const quantityControl = getFormikQuantity();
							if (quantityControl < props.maxNumberOfProduct) {
								formik.setFieldValue("quantity", quantityControl + 1);
							}
						}}
					/>
				</Grid>
				<Grid item xs={1} sm={1}></Grid>
				<Grid item xs={12} sm={12}>
					<RxButton
						color="inherit"
						variant="contained"
						label="SEPETE EKLE"
						size="small"
						type="submit"
						id="add_basket"
					/>
				</Grid>
			</Grid>
		</form>
	);
};

export default RxProductActionContent;
